import { defineMessages } from 'react-intl';

const scope = 'cb.containers.AdminPanel.CouponImport';

export default defineMessages({
  pageHeadingText: {
    id: `${scope}.pageHeadingText`,
    defaultMessage: 'Affiliate Business Manager',
  },
  idColumnText: {
    id: `${scope}.idColumnText`,
    defaultMessage: 'ID',
  },
  businessColumnText: {
    id: `${scope}.businessColumnText`,
    defaultMessage: 'Business',
  },
  businessWebUrlColumnText: {
    id: `${scope}.businessWebUrlColumnText`,
    defaultMessage: 'Business Web URL',
  },
  editColumnText: {
    id: `${scope}.editColumnText`,
    defaultMessage: 'Edit',
  },
  deleteColumnText: {
    id: `${scope}.deleteColumnText`,
    defaultMessage: 'Delete',
  },
});
